import React, { useState } from 'react';
import * as Icon from 'react-feather';

const PostInspirationCard = ({ post }) => {
  const [expanded, setExpanded] = useState(false);
  const maxChars = 300;

  if (!post) return null;

  const fullText = post.text?.replace(/\\n/g, '\n') || '';
  const shouldTruncate = fullText.length > maxChars;
  const displayedText = expanded || !shouldTruncate
    ? fullText
    : fullText.slice(0, maxChars) + '...';

  return (
    <>
      <h4>Post Inspiration</h4>
      <div className="card p-1 postinspiration" style={{ borderRadius: 10, minHeight: 400 }}>
        <div className="card-body">
          <div className="d-flex align-items-start mb-2">
            <img
              src={post.avatar}
              className="rounded-circle me-2"
              alt="avatar"
              width="40"
              height="40"
            />
            <div className="flex-grow-1">
              <h6 className="mb-0 fw-bold">{post.author}</h6>
              <small className="text-muted">
                {new Date(post.date_added).toLocaleDateString()}
              </small>
            </div>
          </div>

          <p className="mb-2" style={{ whiteSpace: 'pre-wrap' }}>
            {displayedText}
          </p>

          {shouldTruncate && (
            <button
              onClick={() => setExpanded(prev => !prev)}
              className="btn btn-link p-0 small"
              style={{ textDecoration: 'none' }}
            >
              {expanded ? 'Show less' : 'Show more'}
            </button>
          )}

          {post.main_image && (
            <img
              src={post.main_image}
              alt="post"
              className="w-100 rounded"
            />
          )}

          <div className="d-flex justify-content-start mt-3 text-muted small">
            {post.social_proof !== null && (
              <span className="me-3">
                <Icon.ThumbsUp size={14} className="me-1" />
                {post.social_proof}
              </span>
            )}
            {post.comments !== null && (
              <span>
                <Icon.MessageCircle size={14} className="me-1" />
                {post.comments}
              </span>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PostInspirationCard;
